<template>
    <xx-poi-select
        :size="size"
        @input="input"
        placeholder="请选择DC"
        :processData="processData"
        :selectItems="value"
        v-bind="$attrs"
        v-on="$listeners"
    ></xx-poi-select>
</template>

<script>
/**
 * @author 方涛
 *
 * DC选择器, 基于XxPoiSelect, 只是筛选出DC // 这个组件有问题吧?
 */

import PoiSelect from '../PoiSelect';

export default {
    name: 'XxPoi',
    props: {
        value: {
            required: true
        },
        size: {
            type: String,
            default: 'small'
        }
    },
    components: {
        PoiSelect
    },
    watch: {},
    methods: {
        input(val) {
            this.$emit('input', val);
        },
        processData(data) {
            return data.filter(poi => [1, 2, 3].indexOf(+poi.poiType) > -1);
        }
    }
};
</script>
